import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=4beb0d61&scoped=true&"
import script from "./Tabbar.vue?vue&type=script&lang=js&"
export * from "./Tabbar.vue?vue&type=script&lang=js&"
import style0 from "./Tabbar.vue?vue&type=style&index=0&id=4beb0d61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beb0d61",
  null
  
)

export default component.exports